import React from 'react';

const VoiceDidTable = (props) => {

    return (
        <table width="100%" className="green-table">
            <tbody>
                <tr>
                    <th>Pack option</th>
                    <th>Description</th>
                    <th>Monthly access</th>
                    <th>Total min. cost</th>
                </tr>
                <tr>
                    <td>DID10</td>
                    <td>Additional 10 DIDs</td>
                    <td>$4.00</td>
                    <td>$4.00</td>
                </tr>
                <tr>
                    <td>DID100</td>
                    <td>Additional 100 DIDs</td>
                    <td>$40.00</td>
                    <td>$40.00</td>
                </tr>
            </tbody>
        </table>
    );

};

export default VoiceDidTable;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/VoiceDidTable.js